export default "__VITE_ASSET__DKJMxrQ0__"